// extracted by mini-css-extract-plugin
export default {"cls1":"VeloBookended_cls1__oOQ8P","cls2":"VeloBookended_cls2__Mj63r VeloBookended_cls1__oOQ8P","column":"VeloBookended_column__iy5ds","justify":"VeloBookended_justify__+tSa6"};